import init from '../../../js/init';

const name = 'accordion';
const selector = '.accordion';
const checkboxSelector = '.accordion-item__input';
const contentSelector = '.accordion-item__content';
const multipleClass = `${selector}--multiple`.substring(1);

init(Drupal, name, selector, root => {
  const isMultiple = root.classList.contains(multipleClass);

  const checkboxes = root.querySelectorAll(checkboxSelector);

  root.addEventListener('change', e => {
    checkboxes.forEach(checkbox => {
      if (!isMultiple && checkbox !== e.target)
        checkbox.checked = false;

      const content = checkbox.parentNode.querySelector(contentSelector);
      content.style.maxHeight = checkbox.checked ? `${content.scrollHeight}px` : '0px';
    });
  });
});
